
import {defineComponent,ref} from 'vue'
import store from '@/store'
import {setTimestamp} from '@/utils/auth'
export default defineComponent({
  emits:['authenticated','cancel'],
  setup(_props,{emit}){
    const username=ref(''),password=ref(''),busy=ref(false),error=ref('')
    const submit=async()=>{
      if(busy.value)return
      if(!username.value.trim() || !password.value){error.value='请输入账号和密码。';return}
      busy.value=true;error.value=''
      try{
        await store.dispatch('user/login',{username:username.value.trim(),password:password.value,remebmer:false})
        setTimestamp();password.value='';emit('authenticated')
      }catch(reason:any){error.value=reason?.message || '登录失败，请核对账号和密码。'}
      finally{busy.value=false}
    }
    return {username,password,busy,error,submit}
  }
})
